import { useAlert, useAuth } from 'core/contexts';
import { useQuery, UseQueryResult } from 'react-query';
import { commonShowAlert } from '../lib';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { StepsTypeMap, StepTypeLabel } from 'pages/pipelines/pipelines-helper';
import { AxiosResponse } from 'axios';

export interface StepListResponse {
    id: string;
    name: string;
    type: StepTypeLabel;
    description: string;
    inPipelines: number;
    pipelineInfo: {
        id: string;
        name: string;
        description: string;
    }[];
}

const getStepsList = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useStepsList = (
    isEnabled: boolean
): UseQueryResult<StepListResponse[], Error> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const url = '/metadata/datapipeline/summary';

    return useQuery(
        'steps',
        async () =>
            (await getStepsList(url, getToken())).data.map((item: any) => ({
                ...item,
                type: StepsTypeMap[item.type] || item.type,
                inPipelines: item.pipelineInfo.length,
            })),
        {
            enabled: isEnabled,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ?? 'Unable to retrieve steps data';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
